import ServicePage from '../../components/Pages/ServicePage';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function ServicePageWrapper({cityId}) {
  const shouldBePage = pages.service;
  const conditionTypes = {
    page: true,
    franchise: true,
  };

  return (
    <PageWrapper
      pageToLoad={<ServicePage />}
      shouldBePage={shouldBePage}
      cityId={cityId}
      conditions={conditionTypes}
    />
  );
}
